import { render, staticRenderFns } from "./AppDragAndDrop.vue?vue&type=template&id=5881f095&"
import script from "./AppDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./AppDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./AppDragAndDrop.vue?vue&type=style&index=0&id=5881f095&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports